import { PublicClientApplication } from '@azure/msal-browser'
import { msalConfig } from '@/config/authConfig'

/**
 * MSAL should be instantiated outside of the component tree to prevent it from being re-instantiated on re-renders.
 * For more, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
 */

export const msalInstance = new PublicClientApplication(msalConfig)
